import { Tag } from '@clarion-blueprint-shim';
import { MenuTrigger } from 'react-aria-components';
import { useWorkspaceMembers } from '../auth/useWorkspaceMembers';
import { ClarionButton } from '../clarion/ClarionButton';
import { ClarionMenu, ClarionMenuItem } from '../clarion/ClarionMenu';
import { formatRoleName } from '../workspace/permission';
import UserAvatar from './UserAvatar';

interface AssigneeMultiSelectProps {
  workspaceId: string;
  selectedUserIds: string[];
  onSelectionChange: (userIds: string[]) => void;
}

export default function AssigneeMultiSelect({
  workspaceId,
  selectedUserIds,
  onSelectionChange,
}: AssigneeMultiSelectProps) {
  const { workspaceMembers } = useWorkspaceMembers(workspaceId);
  const selectedMembers = workspaceMembers.filter((m) => selectedUserIds.includes(m.userId));

  return (
    <MenuTrigger>
      <ClarionButton variant="outlined" endIcon="chevron-down" fill textAlign="left">
        {selectedMembers.length === 0 ? (
          'Search members…'
        ) : (
          <ul className="flex flex-wrap grow gap-2">
            {selectedMembers.map((member) => (
              <li key={member.userId} className="flex items-center gap-1">
                <UserAvatar user={member} size={20} />
                <span>{member.name || member.email || member.userId}</span>
              </li>
            ))}
          </ul>
        )}
      </ClarionButton>
      <ClarionMenu
        selectionMode="multiple"
        selectedKeys={selectedUserIds}
        onSelectionChange={(keys) => {
          if (typeof keys !== 'string') {
            onSelectionChange(Array.from(keys) as string[]);
          }
        }}
      >
        {workspaceMembers.map((member) => (
          <ClarionMenuItem key={member.userId} id={member.userId}>
            <UserAvatar user={member} size={24} />
            <div className="grow">
              <div>{member.name || 'Unnamed User'}</div>
              <div className="text-xs opacity-70">{member.email}</div>
            </div>
            <Tag minimal>{formatRoleName(member.role)}</Tag>
          </ClarionMenuItem>
        ))}
      </ClarionMenu>
    </MenuTrigger>
  );
}
